import React from 'react'
import Image from 'components/Image'
import goodlesImage from 'images/goodles.jpg'
import mccormickImage from 'images/mc-cormick.jpg'
import genVImage1 from 'images/experiential-marketing/genV/image_1.jpg'
import genVImage2 from 'images/experiential-marketing/genV/image_2.jpg'
import genVImage3 from 'images/experiential-marketing/genV/image_3.jpg'
import presidentialCampaignImage1 from 'images/experiential-marketing/presidential-campaign/1.jpg'
import presidentialCampaignImage2 from 'images/experiential-marketing/presidential-campaign/2.jpg'
import presidentialCampaignImage3 from 'images/experiential-marketing/presidential-campaign/3.jpg'
import presidentialCampaignImage4 from 'images/experiential-marketing/presidential-campaign/4.jpg'
import presidentialCampaignImage5 from 'images/experiential-marketing/presidential-campaign/5.jpg'
import LiteVimeo from 'components/LiteVimeo'

const GenVSection = () => (
  <div
    className="lg:grid lg:grid-cols-2 lg:gap-16 lg:items-start py-10 sm:py-16 flex flex-col gap-y-4"
    id="gen-v"
  >
    <div className="relative mx-auto max-w-md sm:max-w-3xl">
      <div>
        <p className="text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-5xl">
          Amazon Prime - Gen V
        </p>
        <div className="mt-6 space-y-6 text-gray-700 prose lg:prose-lg md:max-w-screen-lg mx-auto text-justify">
          <p>
            Another amazing branded food truck campaign in the books! BFT was
            happy to work with the{' '}
            <a
              className="font-semibold underline-none"
              href="https://www.producexm.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Produce Group
            </a>{' '}
            and Amazon Prime to promote their new show{' '}
            <a
              className="font-semibold"
              href="https://www.amazon.com/Gen-V-Season-1/dp/B0CBFTRGPZ"
              rel="noopener noreferrer"
              target="_blank"
            >
              &quot;GEN V&quot;
            </a>
            . A spin off of the hit show &quot;The Boys&quot;, the Gen V series
            was targeting the younger college demographic and asked BFT to
            provide full service marketing support through their many channels
            in the mobile industry.
          </p>
          <p>
            BFT did just that by providing a fully custom wrapped food truck to
            mimic a popular fast food chain in the show called &quot;Vought A
            Burger&quot;. Serving up delicious burgers, fries, drinks and merch
            to help engage with college students at high impact moments in Los
            Angeles & New York. BFT spared no details by adding custom food
            packaging, uniforms and a branded bi-coastal delivery team to parade
            the streets of LA & NY, handing out cases of meals to large media
            companies in the film and TV industries.
          </p>
        </div>

        <div className="relative rounded-2xl shadow-xl overflow-hidden flex mt-4">
          <Image
            alt="Gen V image"
            className="object-cover object-center"
            height={800}
            src={genVImage3}
            width={900}
          />
        </div>
      </div>
    </div>

    <div className="flex flex-col gap-y-4 h-full mx-auto max-w-md sm:max-w-3xl">
      <div className="relative rounded-2xl shadow-xl overflow-hidden flex">
        <Image
          alt="Gen V image"
          className="object-cover object-center"
          src={genVImage1}
        />
      </div>
      <div className="relative rounded-2xl shadow-xl overflow-hidden flex">
        <Image
          alt="Gen V image"
          className="object-cover object-center"
          height={1080}
          src={genVImage2}
          width={900}
        />
      </div>
    </div>
  </div>
)
const GoodlesSection = () => (
  <div
    className="lg:grid lg:grid-cols-3 lg:gap-10 lg:items-start pt-6 py-10 sm:py-16"
    id="goodles"
  >
    <div className="col-span-1 relative mx-auto max-w-md sm:max-w-3xl">
      <div className="space-y-6 text-gray-700 prose lg:prose-lg md:max-w-screen-lg mx-auto text-justify">
        <p className="text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-5xl">
          GOODLES
        </p>
        <p>
          It was great working with the The GOODLES team to bring out one of our
          best looking experiential marketing branded trucks ever! The multiple
          Mac and Cheese flavors were second to none and everyone was so excited
          to meet celebrity & co-founder of Goodles, Gal Gadot.
        </p>
        <p>
          We love seeing our clients using a food truck to promote their
          products! What a wonderful event in Los Angeles and we look forward to
          the Food Truck Experiential Marketing Events we have planned across
          the country for 2023!
        </p>
        <p>
          Go get yourself a treat and try some GOODLES Mac and Cheese! You
          won&apos;t be disappointed!
        </p>
      </div>
    </div>
    <div className="col-span-1 relative mt-4 mx-auto lg:m-0 max-w-md sm:max-w-3xl">
      <div className="relative aspect-w-9 aspect-h-16">
        <LiteVimeo
          className="rounded-2xl shadow-xl"
          previewId="1577320027-e5b60f99a8ed651051864a2b9a7f0e39d2ba7d950639ce5e8fd69b2a52484fce-d"
          videoId="1023532285"
        />
      </div>
    </div>
    <div className="col-span-1 mx-auto lg:m-0 max-w-md sm:max-w-3xl h-full mt-4 lg:mt-0">
      <div className="rounded-2xl shadow-xl overflow-hidden flex h-full">
        <Image
          alt="GOODLES image"
          className="object-cover object-center aspect-w-9 aspect-h-16 w-full"
          src={goodlesImage}
        />
      </div>
    </div>
  </div>
)
const McCormickSection = () => (
  <div
    className="lg:grid lg:grid-cols-2 lg:gap-16 lg:items-start py-10 sm:py-16 flex flex-col gap-y-4"
    id="mccormick"
  >
    <div className="relative mx-auto max-w-md sm:max-w-3xl">
      <div>
        <p className="text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-5xl">
          McCormick Taco Seasoning
        </p>
        <div className="mt-6 space-y-6 text-gray-700 prose lg:prose-lg md:max-w-screen-lg mx-auto text-justify">
          <p>
            The household name we’ve always known has hit the streets in style
            with BFT designed activations in Los Angeles, New York and
            Washington DC. Serving hundreds of free tacos, seasoned to
            perfection with the original McCormick Taco Seasoning that’s been in
            our pantries since before we could reach the top shelf. Sometimes we
            need to remind the old generation how great their old favorites are
            while introducing the new generation to the classics by using a
            modern platform they’re familiar with. Original brands like
            McCormick have leveraged a new school trend to deliver an old school
            product to both new and old customers alike.
          </p>
          <p>
            Best Food Trucks (BFT) teamed up with McCormick in 3 major markets,
            providing a one stop shop service to manage everything needed from
            A-Z to make these bi-coastal activations go off without a hitch.
            From renting, designing and wrapping of the food trucks, providing
            experienced chefs, and mixing in some branded swag and supplies, the
            McCormick trucks didn’t go unseen while parked or cruising the
            streets.
          </p>
          <p>
            Creating buzz, educating targeted demographics and increasing
            impressions is what we do best. How can you have the “Best”
            activations without partnering with Best Food Trucks?
          </p>
        </div>
      </div>
    </div>

    <div className="relative mx-auto max-w-md sm:max-w-3xl lg:max-w-none">
      <div className="relative rounded-2xl shadow-xl overflow-hidden flex">
        <Image
          alt="McCormick image"
          className="object-cover object-center"
          height={800}
          src={mccormickImage}
          width={900}
        />
      </div>
    </div>
  </div>
)
const PresidentialCampaignSection = () => (
  <div className="py-10 sm:py-16" id="presidential-campaign">
    <div className="lg:grid grid-cols-2 gap-x-6 pt-6">
      <div className="space-y-6 text-gray-700 prose lg:prose-lg md:max-w-screen-lg mx-auto text-justify">
        <p className="text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-5xl text-left">
          Presidential Campaign - Harris/Walz
        </p>
        <p>
          BFT had the incredible opportunity to collaborate on a campaign
          activation for the Harris/Walz team right here in Las Vegas! Our team
          at Best Food Trucks Inc. managed the logistics, design, and service
          for a unique experience: a fully wrapped food truck, custom serving
          trays, and branded napkins that all brought the campaign’s message
          directly to the people.
        </p>
        <p>
          The food truck made its way through Las Vegas, serving up delicious
          tacos and connecting with the community in an impactful, memorable
          way. It was an honor to be a part of such a historic campaign and to
          see the positive energy and excitement it generated among everyone who
          visited the truck.
        </p>
        <p>
          A huge thank you to everyone involved who made this event a success. A
          very special thank you to celebrity guests, Eva Longoria and Jordana
          Brewster for coming out to the truck and showing their support! We’re
          excited to continue making waves in experiential marketing and
          supporting powerful campaigns like this one!
        </p>
      </div>
      <div>
        <div className="relative rounded-2xl shadow-xl overflow-hidden flex">
          <Image
            alt="Presidential Campaign image"
            className="object-cover object-center"
            height={500}
            src={presidentialCampaignImage1}
            width={900}
          />
        </div>
        <div className="mt-4 relative rounded-2xl shadow-xl overflow-hidden flex">
          <Image
            alt="Presidential Campaign image"
            className="object-cover object-center"
            height={500}
            src={presidentialCampaignImage2}
            width={900}
          />
        </div>
      </div>
    </div>
    <div className="grid grid-cols-3 gap-4 mt-4">
      <div className="relative rounded-2xl shadow-xl overflow-hidden flex">
        <Image
          alt="Presidential Campaign image"
          className="object-cover object-center"
          height={800}
          src={presidentialCampaignImage3}
          width={420}
        />
      </div>
      <div className="relative rounded-2xl shadow-xl overflow-hidden flex">
        <Image
          alt="Presidential Campaign image"
          className="object-cover object-center"
          height={800}
          src={presidentialCampaignImage4}
          width={420}
        />
      </div>
      <div className="relative rounded-2xl shadow-xl overflow-hidden flex">
        <Image
          alt="Presidential Campaign image"
          className="object-cover object-center"
          height={800}
          src={presidentialCampaignImage5}
          width={420}
        />
      </div>
    </div>
  </div>
)

const Tabs = () => (
  <div className="flex flex-wrap mt-4 gap-x-4 gap-y-2">
    {[
      {
        name: 'Presidential Campaign - Harris/Walz',
        link: 'presidential-campaign'
      },
      {
        name: 'Amazon Prime - Gen V',
        link: 'gen-v'
      },
      {
        name: 'GOODLES',
        link: 'goodles'
      },
      {
        name: 'McCormick Taco Seasoning',
        link: 'mccormick'
      }
    ].map((tab) => (
      <a
        key={tab.name}
        className="text-gray-600 hover:text-gray-800 font-light border-solid border border-gray-300 rounded-md px-2 py-1 text-sm cursor-pointer"
        href={`#${tab.link}`}
      >
        {tab.name}
      </a>
    ))}
  </div>
)

const ClientCaseSection = () => (
  <div className="w-full">
    <div className="lg:mx-auto lg:max-w-7xl px-4 pb-12 md:pb-24 pt-8 md:pt-12">
      <div className="relative max-w-md sm:max-w-3xl sm:mx-auto lg:mx-0">
        <h2 className="text-2xl font-semibold text-orange-600 uppercase tracking-wide">
          Recent Satisfied Clients
        </h2>
      </div>
      <Tabs />
      <div className="flex flex-col gap-y-10 lg:gap-y-20 divide-solid divide-gray-200 divide-y">
        <PresidentialCampaignSection />
        <GenVSection />
        <GoodlesSection />
        <McCormickSection />
      </div>
    </div>
  </div>
)

export default ClientCaseSection
